import { Button } from '@mui/material';

type CloseButtonCLickHandler = () => void;

function CloseButton({ updateHandler, show = true }: { updateHandler: CloseButtonCLickHandler, show?: boolean }) {
  return (
    <Button
      variant="contained"
      size="small"
      color="error"
      sx={{
        display: show ? 'flex' : 'none',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1,
        position: 'absolute',
        top: -10,
        right: -10,
        backgroundColor: '#BFBFBF8A',
        fontSize: 14,
        width: 20,
        minWidth: 20,
        height: 20,
        minHeight: 20,
        padding: 0,
      }}
      onClick={(event) => {
        updateHandler();
        event.stopPropagation();
      }}
    >
      {' '}
      ×
      {' '}
    </Button>
  );
}

export default CloseButton;
